<div>
  <div class="flex flex-col">
    <span class="text-2xl font-semibold">4. Añadir RPTs</span>
    <span class="text-neutral-dark mt-2 mb-8">
      Añade las personas físicas o RTPs que necesiten adherirse a {{ nameAndRange }}
    </span>
  </div>
  <app-tabs
    class="mt-4"
    [type]="'tabsWithButtons'"
    (tabChanged)="onTabChange($event)"
    [items]="tabsItems()">
    <app-search-bar
      [showExternalButton]="true"
      [placeholder]="'Buscar nombre, primer apellido, segundo apellido, puesto o código de organismo'"
      (search)="selectedTab() === '1' ? handleSearchTeam($event) : handleSearchAll($event)" />
    <ng-container>
      <div class="mt-4">
        <div class="flex justify-between items-center">
          <span>{{ selectedTab() === '1' ? totalResultsTeams() : totalResultsAll() }} RPTs sugeridos</span>
        </div>
        <desy-table-advanced
          classes="min-w-full"
          idPrefix="table-with-all"
          [hasCheckboxes]="true"
          (rowsChecked)="selectRpt($event)"
          [wrapper]="{ classes: 'overflow-x-auto' }">
          <desy-table-advanced-header>
            <desy-table-advanced-header-cell>
              <desy-content>Nombre</desy-content>
            </desy-table-advanced-header-cell>
            <desy-table-advanced-header-cell>
              <desy-content>Puesto</desy-content>
            </desy-table-advanced-header-cell>
            <desy-table-advanced-header-cell>
              <desy-content>Organismo</desy-content>
            </desy-table-advanced-header-cell>
            <desy-table-advanced-header-cell>
              <desy-content>Email</desy-content>
            </desy-table-advanced-header-cell>
          </desy-table-advanced-header>
          @if (selectedTab() === '1') {
            @for (c of rptsTeams; track c.jobCode) {
              <desy-table-advanced-row [id]="c.jobCode">
                <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.rpt }} - {{ c.position }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
              </desy-table-advanced-row>
            }
          } @else {
            @for (c of rptsAll; track c.jobCode) {
              <desy-table-advanced-row [id]="c.jobCode">
                <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.rpt }} - {{ c.position }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
              </desy-table-advanced-row>
            }
          }
          <div class="flex justify-between items-center m-[5px]">
            <app-buttons
              [label]="'Añadir a seleccionados'"
              icon="pi pi-plus"
              [classes]="'bg-primary-base text-white'"
              (click)="addRpts()" />
          </div>
        </desy-table-advanced>
        <app-pagination
          [totalItems]="selectedTab() === '1' ? totalResultsTeams() : totalResultsAll()"
          [paginationSize]="selectedTab() === '1' ? paginationSizeTeamsRpts() : paginationSizeAllRpts()"
          [currentPage]="selectedTab() === '1' ? currentPageTeamsRpts() : currentPageAllRpts()"
          (paginationSizeChange)="
            selectedTab() === '1' ? paginationSizeTeamsRpts.set($event) : paginationSizeAllRpts.set($event)
          "
          (currentPageChange)="
            selectedTab() === '1' ? currentPageTeamsRpts.set($event) : currentPageAllRpts.set($event)
          " />
      </div>
      @if (addedRpts?.length > 0) {
        <div class="mt-4 mb-4">
          <div class="flex justify-between items-center">
            <span>{{ addedRpts.length }} RPT/s seleccionado/s</span>
          </div>
          <desy-table-advanced
            classes="min-w-full"
            idPrefix="table-with-all"
            [wrapper]="{ classes: 'overflow-x-auto' }">
            <desy-table-advanced-header>
              <desy-table-advanced-header-cell>
                <desy-content>Nombre</desy-content>
              </desy-table-advanced-header-cell>
              <desy-table-advanced-header-cell>
                <desy-content>Puesto</desy-content>
              </desy-table-advanced-header-cell>
              <desy-table-advanced-header-cell>
                <desy-content>Organismo</desy-content>
              </desy-table-advanced-header-cell>
              <desy-table-advanced-header-cell>
                <desy-content>Email</desy-content>
              </desy-table-advanced-header-cell>
            </desy-table-advanced-header>
            @for (c of addedRpts; track c.jobCode) {
              <desy-table-advanced-row [id]="c.jobCode">
                <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.position }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
                <desy-table-advanced-row-cell>
                  <p-button
                    (click)="removeRpt(c.jobCode)"
                    icon="pi pi-times"
                    [rounded]="true"
                    [text]="true"
                    severity="danger" />
                </desy-table-advanced-row-cell>
              </desy-table-advanced-row>
            }
          </desy-table-advanced>
        </div>
      }
      <app-buttons
        [disabled]="!addedRpts?.length"
        (click)="emitStep4Data()"
        [label]="'Guardar cambios'"
        class="mt-4" />
    </ng-container>
  </app-tabs>
</div>
